import { ORDER_METHODS } from '../../../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.DELIVERY]: 'livraison',
    [ORDER_METHODS.PICKUP]: 'retrait',
    [ORDER_METHODS.ON_SITE]: 'table',
  },
  feedback: {
    payment_method_disabled: "Nous n'acceptons pas les paiements {{paymentMethod}} pour les commandes {{orderMethod}}",
    cash_disabled: "Nous n'acceptons pas les paiements en espèces pour les commandes {{orderMethod}}",
  },
};
